import Vue from 'vue'

import VueShopifyDraggable from 'vue-shopify-draggable'

Vue.use(VueShopifyDraggable.DraggableContainer)
Vue.use(VueShopifyDraggable.Sortable)
Vue.use(VueShopifyDraggable.Swappable)
Vue.use(VueShopifyDraggable.Droppable)
Vue.use(VueShopifyDraggable.Draggable)
